import type { Product } from '@scayle/storefront-nuxt'
import { Locale } from '~/config/locales'
import type { SbContentPage } from '~/cms/storyblok/types/storyblok.d.ts'

/**
 * Single general size guide CMS path per locale.
 * SizeGuide.vue always resolves to this document – no category-specific overrides.
 */
const DEFAULT_PATHS: Record<Locale, string> = {
  [Locale.De]: '/c/service/groessentabellen/',
  [Locale.Ch]: '/c/service/groessentabellen/',
  [Locale.At]: '/c/service/groessentabellen/',
  [Locale.Nl]: '/c/service/onze-maattabellen/',
  [Locale.Be]: '/c/service/onze-maattabellen/',
  [Locale.FrBe]: '/c/service/nos-tableaux-de-tailles/',
  [Locale.FrCh]: '/c/service/nos-tableaux-de-tailles/',
  [Locale.Fr]: '/c/service/nos-tableaux-de-tailles/',
  [Locale.Uk]: '/c/service/groessentabellen/',
}

const useProductSizeGuide = (_product: Product) => {
  const currentShop = useCurrentShop()
  const { data, fetchBySlug, fetching } = useCms<SbContentPage>(
    `size-guide-${currentShop.value.locale}`,
  )

  const sizeGuidePath = computed(
    () => DEFAULT_PATHS[currentShop.value.locale as Locale],
  )

  const getSizeGuide = async () => {
    await fetchBySlug(sizeGuidePath.value)
  }

  return {
    getSizeGuide,
    sizeGuide: computed(() => data.value?.content?.content),
    fetching,
  }
}

export default useProductSizeGuide
